import React from 'react';

function MapPin() {
  return (
    <svg width={27.424} height={35.696} viewBox="0 0 20.568 28.272">
      <path
        d="M10.587.002C5.54-.113.683 5.192.032 11.069-.62 16.946 9.01 28.272 10.319 28.272c1.683 0 10.304-10.23 10.249-16.815-.043-5.071-4.933-11.34-9.98-11.455Z"
        style={{
          fill: '#2f3c48',
          fillOpacity: 1,
          stroke: 'none',
          strokeWidth: 13.3936,
        }}
      />
      <path
        d="M 10.788076,4.4874549 A 1.7010798,1.8584807 0 0 0 9.0871477,6.3452348 1.7010798,1.8584807 0 0 0 10.788076,8.2043513 1.7010798,1.8584807 0 0 0 12.489003,6.3452348 1.7010798,1.8584807 0 0 0 10.788076,4.4874549 Z m 3.533731,1.8390684 A 1.2663593,1.5956654 0 0 0 13.055531,7.9223429 1.2663593,1.5956654 0 0 0 14.321807,9.5181626 1.2663593,1.5956654 0 0 0 15.588082,7.9223429 1.2663593,1.5956654 0 0 0 14.321807,6.3265233 Z M 7.0834446,6.5149744 A 1.2474585,1.4454851 0 0 0 5.8360079,7.9597659 1.2474585,1.4454851 0 0 0 7.0834446,9.4058938 1.2474585,1.4454851 0 0 0 8.330881,7.9597659 1.2474585,1.4454851 0 0 0 7.0834446,6.5149744 Z M 10.825754,9.4058938 C 7.3992256,9.394867 6.1904236,14.574936 6.3271777,18.379372 c 0.074883,2.083215 2.8565526,-1.251635 4.0450853,-1.502262 1.66111,-0.35028 3.249964,2.204709 4.043741,0.713709 1.273606,-2.392302 -0.501171,-8.1749843 -3.59025,-8.1849252 z M 5.3058138,10.157025 A 0.86944077,1.1075795 0 0 0 4.4365106,11.263674 0.86944077,1.1075795 0 0 0 5.3058138,12.37166 0.86944077,1.1075795 0 0 0 6.1751169,11.263674 0.86944077,1.1075795 0 0 0 5.3058138,10.157025 Z"
        fill="#fff"
      />
    </svg>
  );
}

export default MapPin;
